import { createRouter, createWebHistory } from "vue-router";
import {
  hasNubiaLogin,
  NUBIA_CALLBACK_PATH,
  redirectToNubiaAuth,
} from "@/utils/nubiaAuth";

const routes = [
  {
    path: "/",
    alias: "/model-select",
    name: "home",
    component: () => import("@/views/home/HomeView.vue"),
    meta: {
      title: "分类页",
      keepAlive: true,
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search/SearchView.vue"),
    meta: {
      title: "搜索",
    },
  },
  {
    path: "/detail",
    alias: "/estimate",
    name: "detail",
    component: () => import("@/views/detail/DetailView.vue"),
    meta: {
      title: "询价详情",
    },
  },
  {
    path: "/submit-order",
    name: "submitOrder",
    component: () => import("@/views/order/SubmitOrderView.vue"),
    meta: {
      title: "提交订单"
    },
  },
  {
    path: "/user-agreement",
    name: "userAgreement",
    component: () => import("@/views/agreement/UserAgreementView.vue"),
    meta: {
      title: "用户服务协议",
    },
  },
  {
    path: "/order-success",
    name: "orderSuccess",
    component: () => import("@/views/order/OrderSuccessView.vue"),
    meta: {
      title: "下单成功"
    },
  },
  {
    path: "/order-detail",
    name: "orderDetail",
    component: () => import("@/views/order/OrderDetailView.vue"),
    meta: {
      title: "订单详情",
      requiresAuth: true,
    },
  },
  {
    path: "/modify-appointment",
    name: "modifyAppointment",
    component: () => import("@/views/order/ModifyAppointmentView.vue"),
    meta: {
      title: "修改预约信息",
      requiresAuth: true,
    },
  },
  {
    path: "/inspection-report",
    name: "inspectionReport",
    component: () => import("@/views/order/InspectionReportView.vue"),
    meta: {
      title: "验机评估报告"
    },
  },
  {
    path: "/fill-logistics",
    name: "fillLogistics",
    component: () => import("@/views/logistics/LogisticsFillView.vue"),
    meta: {
      title: "填写物流"
    },
  },
  {
    path: "/logistics-detail",
    name: "logisticsDetail",
    component: () => import("@/views/logistics/LogisticsDetailView.vue"),
    meta: {
      title: "物流详情"
    },
  },
  {
    path: NUBIA_CALLBACK_PATH,
    name: "nubiaCallback",
    component: () => import("@/views/oauth/NubiaCallbackView.vue"),
    meta: {
      title: "登录中",
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// 进入需登录页面前校验红魔登录态，无登录态则整页跳转红魔授权登录。
router.beforeEach((to) => {
  if (!to.meta.requiresAuth) return true;
  if (hasNubiaLogin()) return true;
  if (!redirectToNubiaAuth(to)) {
    return {
      name: "nubiaCallback",
      query: { error: "login-config" },
    };
  }
  return false;
});

router.afterEach((to) => {
  const pageTitle = to.meta.title
    ? `${to.meta.title}-${import.meta.env.VITE_APP_TITLE}`
    : import.meta.env.VITE_APP_TITLE;
  document.title = pageTitle;
});

export default router;
